define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 面渲染效果模式。
     *
     * @exports EnumPolygonEffectMode
     * 
     * @see Polygon#effectMode
     */
    var EnumPolygonEffectMode = {
        /**
         * 普通模式。
         * @type {String}
         * @constant
         */
        NULL: "NULL",

        /**
         * SOS模式。
         * @type {String}
         * @constant
         */
        SOS: "SOS",

        /**
         * 衰减模式。
         * @type {String}
         * @constant
         */
        DECAY: "DECAY",

        /**
         * 增长模式。
         * @type {String}
         * @constant
         */
        GROWTH: "GROWTH",

        /**
         * 心跳模式。
         * @type {String}
         * @constant
         */
        HEART: "HEART",

        /**
         * 正弦模式。
         * @type {String}
         * @constant
         */
        SINE: "SINE"
    }
    freezeObject(EnumPolygonEffectMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {String} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumPolygonEffectMode) {
            if (EnumPolygonEffectMode.hasOwnProperty(key) && EnumPolygonEffectMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        NULL: "NULL",
        SOS: "SOS",
        DECAY: "DECAY",
        GROWTH: "GROWTH",
        HEART: "HEART",
        SINE: "SINE",
        getName: getName
    }
})